export const perfInputOptions = {
  trigger: "onBlur",
  valuePropName: "defaultValue"
};

export function isNumeric(n) {
  return (!isNaN(parseFloat(n)) && isFinite(n));
}